import React from 'react';
import { HStack, Button, ButtonText } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

const EventTaskFooterActions = ({
  showRegisterAgain,
  onRegisterAgain,
  showMarkDone,
  onMarkDone,
  markDoneLoading,
  markDoneLabel,
}) => {
  const { t } = useTranslation();

  if (!showRegisterAgain && !showMarkDone) return null;

  return (
    <HStack justifyContent="flex-end" space="lg" mt="$2" flexWrap="wrap">
      {showRegisterAgain && (
        <Button variant="link" size="xs" action="primary" onPress={onRegisterAgain}>
          <ButtonText textDecorationLine="underline" fontWeight="medium">
            {t('student.eventTask.registerAnother', 'Register for Another Session')}
          </ButtonText>
        </Button>
      )}

      {showMarkDone && (
        <Button
          variant="link"
          size="xs"
          action="secondary"
          onPress={onMarkDone}
          isDisabled={markDoneLoading}
          isLoading={markDoneLoading}
        >
          <ButtonText textDecorationLine="underline" color="$textLight500">
            {markDoneLabel || t('student.eventTask.markDoneLink', 'Skip event, mark as done')}
          </ButtonText>
        </Button>
      )}
    </HStack>
  );
};

export default EventTaskFooterActions;
